import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SOJINVSearchCom} from '../containers'
function SOJINVSearchComPage() {
    //we are inet so id is not passed
    console.log('SV*****SOJINVSearchComPage')
    let { id } = useParams();
    let svparams = { 'id': id}

    console.log('SV*****SOJINVSearchComPage',svparams)
    
    return (
        <SOJINVSearchCom svparams={svparams} ></SOJINVSearchCom>
        
    );
}
export default SOJINVSearchComPage